import { compose, hoistStatics, withHandlers, withProps } from 'recompose';
import { translate } from 'react-i18next';
import { withRouter } from 'react-router-dom';
import moment from 'moment';
import Comment from './Comment';
import UserService from '../../../services/user.service';

const enhance = compose(
  translate('portal'),
  withProps((props) => {
    const { item: { created_at, creator } } = props;
    const duration = moment.duration(moment().diff(props.item.created_at));
    const hours = duration.asHours();
    const convTime = hours >= 24 ?
      moment(created_at).format('HH:mm, MMM D') :
      `${moment(created_at).format('HH:mm')}, ${props.t('Today')}`;
    const src = UserService.getAvatar({ avatar: creator.avatarImg, avatar_url: creator.avatar_url }, 150, 150, true);
    return {
      ...props,
      src,
      time: convTime,
      creator: creator.first_name && creator.last_name ?
        `${creator.first_name} ${creator.last_name}` : creator.email };
  }),
  withHandlers({
  }),
);

export default withRouter(hoistStatics(enhance)(Comment));



// WEBPACK FOOTER //
// ./src/components/comments/comment/index.js